$(document).ready(function() {

    let tooltipStart = function() {

        if (typeof $.fn.tooltip.constructor === 'undefined') {
            throw new Error('Bootstrap Tooltip must be included first!');
        }

        let Tooltip = $.fn.tooltip.constructor;

        $.extend(Tooltip.Default, {
            customClass: ''
        });

        let _show = Tooltip.prototype.show;

        Tooltip.prototype.show = function() {
            _show.apply(this, Array.prototype.slice.apply(arguments));

            if (this.config.customClass) {
                let tip = this.getTipElement();
                $(tip).addClass(this.config.customClass);
            }
        };

        // setTimeout(function() {
            $('[data-toggle="tooltip"]').tooltip();
        // }, 3000);

        function debounce(fn, delay) {
          var timer = null;
          return function () {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
              fn.apply(context, args);
            }, delay);
          };
        }

        function ditool(){
            if ($('.difficulty-icon').isInViewport()) {
                $('.difficulty-icon').tooltip();
            }
        }

        var myDebouncedFunction = debounce(ditool, 50);

        if ($('.difficulty-icon').length > 0 ) {
            console.log($('.difficulty-icon').length);
            $(window).scroll(myDebouncedFunction);
        }
    }

    setTimeout(tooltipStart, 1500);
});
